// extracted by mini-css-extract-plugin
export default {"up_arrow":"ScroolUp_up_arrow__YeChW","up_arrow_btn":"ScroolUp_up_arrow_btn__--4Ib","up_arrow_icon":"ScroolUp_up_arrow_icon__fn1ak"};